export default __webpack_public_path__ + "static/media/Class_4_Sample_QP.d55ea199.jpg";